export abstract class MachiningsEvent {}

export class MachiningsLoad extends MachiningsEvent {}
